import {
  GET_MESSAGING_SERVICE,
  GET_MESSAGING_SERVICE_ERROR,
  GET_MESSAGING_SERVICE_SUCCESS,
} from "../actions/messaging";

const initialState = {
  messages: [],
  isLoading: false,
  error: undefined,
};

export default function messagingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MESSAGING_SERVICE:
      return {
        ...state,
        isLoading: true,
      };
    case GET_MESSAGING_SERVICE_SUCCESS:
      return {
        ...state,
        messages: action.messages,
        isLoading: false,
        error: undefined,
      };
    case GET_MESSAGING_SERVICE_ERROR:
      return {
        ...state,
        error,
        isLoading: false,
      };
    default:
      return { ...state };
  }
}
